import React, { useMemo, useCallback }        from 'react';
import { connect }                            from 'react-redux';
import { SubmissionError, formValueSelector } from 'redux-form';
import { useTranslation }                     from 'react-i18next';

import AuthForm        from '../../../components/sidebars/components/AuthForm';
import { useUser }     from '../../../providers/user';
import { useWhereBuy } from '../../../providers/whereBuy';
import Preloader       from '../../../components/containers/preloader';
import RenderButton    from '../../../components/buttons/base/RenderButton';
import { hasAccess }   from '../../../../common/services/accessChecker';

import '../scss/style.scss';

const LoginPage = (props) => {
  const {
          emailForm,
        } = props;

  const { t }                          = useTranslation();
  const {
          address,
          authorized,
          cityLabel,
          email: userEmail,
          isActive,
          login,
          logout,
          name,
          phone,
          _token,
          userInitialStateLoaded,
        }                              = useUser();

  const { cities: allowedCities = [] } = useWhereBuy();

  const email = useMemo(() => emailForm || userEmail || null, [emailForm, userEmail]);

  const submitAuthForm = useCallback((event, handleSubmit) => {
    event.preventDefault();

    handleSubmit((values) => {
      return login(values, allowedCities)
        .catch((error) => {
          throw new SubmissionError(error);
        });
    })(event);
  }, [login, allowedCities]);

  const getAuthFormProps = useCallback(() => {
    let props = {
      email,
      isActive,
      submitForm: submitAuthForm,
    };

    if (userInitialStateLoaded) {
      props.initialValues = { _token };
    }

    return props;
  }, [email, isActive, submitAuthForm, userInitialStateLoaded, _token]);

  return (
    !_token ? (
      <Preloader />
    ) : authorized ? (
      <div className="profile">
        <div className="list">
          <div>
            <span>{t('field_firstName')}:</span>
            <span>{t('field_lastName')}:</span>
            <span>E-mail:</span>
            <span>{t('field_phone')}:</span>
            <span>{t('field_address')}:</span>
            <span>{t('field_cityLabel')}:</span>
          </div>
          <div>
            <span className={'label'}>{name.first_name || t('client_notFilled')}</span>
            <span className={'label'}>{name.last_name || t('client_notFilled')}</span>
            <span className={'label'}>{userEmail || t('client_notFilled')}</span>
            <span className={'label'}>{phone || t('client_notFilled')}</span>
            <span className={'label'}>{address ? `${address?.street || ''} ${address?.blockNumber || ''} ${address?.flatNumber || ''} ${address?.houseNumber || ''}` : t('client_notFilled')}</span>
            <span className={'label'}>{cityLabel || t('client_notFilled')}</span>
          </div>
        </div>
        <div className="btns">
          <RenderButton
            type={'button'}
            action={logout}
            className={'fill'}
            label={t('btn_output')}
          />
          {hasAccess.admin() && (
            <div className="fixed btn fill">
              <a href={'/admin-panel'} className={'btn'}>{t('dashboard_title')}</a>
            </div>
          )}
        </div>
      </div>
    ) : (
      <div className={'login-page'}>
        <h1>{t('label_authorization')}</h1>
        <AuthForm {...getAuthFormProps()} />
      </div>
    )
  );
};

function mapStateToProps(state) {
  const selector = formValueSelector('AuthForm');

  return {
    emailForm: selector(state, 'email'),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);